import { useLocation, useNavigate } from "react-router-dom";
import HexButton from "../../ui-kit/HexButtons";
import { setStorageItem } from "../../utils/common-utils";
import useUser from "../../features/profile/useUser";
import { useState } from "react";
import ConfirmationModal from "../HexModal/ConfirmationModal";
import { getLabel } from "../../hooks/use-labels";

import "./style.css";

const HexAuthButton = ({
  label,
  buttonType,
  onClick,
  disable,
  className,
  buttonProps,
}) => {
  const [modal, setModal] = useState(false);
  const { isAuthenticated } = useUser();

  const navigate = useNavigate();
  const location = useLocation();

  const { search, pathname, state } = location;

  const redirectPath = { path: pathname + search, state };

  const toggleModal = () => {
    setModal((prev) => !prev);
  };

  const goToLogin = () => {
    setStorageItem("redirectPath", redirectPath);
    return navigate("/auth");
  };

  const onButtonClick = () => {
    if (!isAuthenticated) {
      toggleModal();
    } else {
      onClick();
    }
  };

  const otherButtonProps = {
    ...(buttonProps &&  buttonProps ),
  };

  return (
    <div className={className || ""}>
      {modal && (
        <ConfirmationModal
          modalClass="login-confirmation-modal"
          messageClassName="mb-1"
          title={getLabel("loginToContinueLabel")}
          confirmDescription={getLabel("loginConfirmationMessage")}
          showIcon={false}
          confirmText={getLabel("continueBtn")}
          cancelText={getLabel("cancleBtn")}
          onConfirm={goToLogin}
          onCancel={toggleModal}
        />
      )}

      <HexButton
        size="lg"
        disable={disable}
        {...otherButtonProps}
        className="full-width"
        label={label || "Submit"}
        type={buttonType || "primary"}
        onClick={!disable && onButtonClick}
      />
    </div>
  );
};

export default HexAuthButton;
